import React from "react";
import styled from "styled-components";
import { MELOGY_WHITE, MELOGY_TRANSPARENT } from "../style/colors";
import { FONT_SIZE_4XS, TITLE_FONT_FAMILY, TITLE_FONT_WEIGHT } from "../style/fontSettings";

const TitleContainer = styled.div`
    width: 100%;
    max-width: 960px;
    height: 24px;
    min-height: 24px;
    color: ${MELOGY_WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    position: ${({ showSettings }) => showSettings ? "fixed" : "static"};
    bottom: ${({ showSettings }) => showSettings ? "160px" : "auto"};
    background-color: ${MELOGY_TRANSPARENT};
    user-select: none;
`;

const TitleBackground = styled.div`
    width: calc(80% + 64px);
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const TitleIcon = styled.div`
    width: 32px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${MELOGY_WHITE};
`;

const TitleText = styled.div`
    font-size: ${FONT_SIZE_4XS};
    font-family: ${TITLE_FONT_FAMILY};
    font-weight: ${TITLE_FONT_WEIGHT};
`;

const Title = ({ text, icon: Icon, showSettings }) => (
    <TitleContainer showSettings={showSettings}>
        <TitleBackground>
            <TitleIcon>
                <Icon />
            </TitleIcon>
            <TitleText>
                {text}
            </TitleText>
        </TitleBackground>
    </TitleContainer>
);

export default Title; 